import React from "react";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet";
import "./PageHeader.css";

export default function PageHeader({ title, description, actions }) {
  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>

      <header className="page-header">
        <div className="page-header__content">
          <h1>{title}</h1>
          {description && (
            <p className="page-header__description">{description}</p>
          )}
        </div>
        {actions && <div className="page-header__actions">{actions}</div>}
      </header>
    </>
  );
}

PageHeader.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  actions: PropTypes.node,
};
